import { KeyboardArrowDown, Language as LanguageIcon } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { useLanguageSelector } from '../hooks/useLanguageSelector';

export const LanguageSelector = () => {
  const { handelChangeLang, handleOpen, currentLang, anchorEl, handleClose, allLang } = useLanguageSelector();
  return (
    <>
      <Button
        onClick={handleOpen}
        sx={{
          minWidth: 'auto',
          padding: '8px 16px',
          color: 'text.primary',
          fontWeight: 'normal',
          '& .MuiSvgIcon-root': {
            fontSize: 20,
            color: 'text.secondary',
          },
        }}
        endIcon={<KeyboardArrowDown />}>
        <LanguageIcon sx={{ mr: 1 }} />
        {currentLang.label}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: { width: 200, maxHeight: 300 },
        }}>
        {allLang.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handelChangeLang(option.value)}
            sx={{
              py: 1,
              px: 2.5,
              '&.Mui-selected': {
                backgroundColor: 'action.selected',
              },
            }}>
            <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
